import { render } from "./ScreeningProgram.vue?vue&type=template&id=992df240"
import script from "./ScreeningProgram.vue?vue&type=script&lang=js"
export * from "./ScreeningProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__